import setLanguage from './setLanguage';

export default setLanguage;
